module.exports = __webpack_public_path__ + "img/dku.02899.ef481945.png";